export const sucessColor = '#0197F6';
export const infoColor = '#0197F6';
export const errorColor = '#F2AF29';
export const warningColor = '#F2AF29';
export const primaryColor = '#211915';
export const secondColor = '#E30613';

export const grayColor = '#F5F5F5';